import {Context} from '@gongxigames/framework/core/fragments/BuilderX/types';
import {Component} from './Component';
import {SpriteProps} from './Sprite';
import {Sprite} from 'pixi.js';

export type ImageProps = SpriteProps & {
    src: string;
};
export class Image extends Component<ImageProps, Sprite> {
    public readonly jsxType: string = 'image';

    static propsFromJson(props: any): ImageProps {
        const propsNormalized = {
            ...super.propsFromJson(props),
            src: props.src
        };

        return propsNormalized;
    }

    public propsToJson(): any {
        const result = super.propsToJson();

        result.src = this.props.src;

        return result;
    }

    public clone(): Image {
        return new Image(this.props);
    }

    public getConstructor(): new () => any {
        return Sprite;
    }

    public updateProps(context: Context, container: Sprite, element: Sprite): void {
        container.texture = context.getTexture(this.props.src)!;

        super.updateProps(context, container, element);
    }
}
